import { AppBar, Toolbar, Typography, Box, Container } from '@mui/material'
import poolwerxLogo from '../assets/poolwerx-logo.png'
import SecretSelector from './SecretSelector'
import { useFranchise } from '../contexts/FranchiseContext'
import { useNavigate } from 'react-router-dom'

function Header() {
  const { selectedFranchise, setSelectedFranchise, fpCode, setFpCode } = useFranchise()
  const navigate = useNavigate()

  const handleFranchiseChange = (value: string, franchise: any) => {
    setSelectedFranchise(franchise)
  }

  const handleHomeClick = () => {
    navigate('/')
  }


  return (
    <AppBar position="sticky" sx={{ bgcolor: '#0c4465', top: 0 }}>
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ py: 1.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            {/* Left side - Logo and title */}
            <Box 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 2,
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.8
                }
              }}
              onClick={handleHomeClick}
            >
              <img 
                src={poolwerxLogo} 
                alt="Poolwerx" 
                style={{ height: '48px' }}
              />
              <Typography 
                variant="h6" 
                component="div" 
                sx={{ 
                  fontWeight: 700, 
                  color: 'white', 
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  marginLeft: '15px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}
              >
                <span style={{ fontSize: '1.2em' }}>🛠️</span>
                EVO PLATFORM API TOOLKIT
              </Typography>
            </Box>

            {/* Right side - Franchise Partner Selector */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography variant="body1" sx={{ color: 'white', fontWeight: 500 }}>
                Franchise Partner:
              </Typography>
              
              <Box sx={{ 
                minWidth: 300,
                maxWidth: 400,
                '& .MuiOutlinedInput-root': {
                  bgcolor: 'white',
                  '& fieldset': {
                    borderColor: 'rgba(255, 255, 255, 0.5)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(255, 255, 255, 0.8)',
                  },
                }
              }}>
                <SecretSelector
                  system="lightspeed"
                  value={fpCode}
                  onChange={handleFranchiseChange}
                  label=""
                />
              </Box>
            </Box>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default Header